const config = {
  get staging() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      helpCenterURL: process.env.VUE_APP_HELP_CENTER_URL,
      adminURL: process.env.VUE_APP_ADMIN_URL,
      instantBaseURL: process.env.VUE_APP_INSTANT_BASE_URL,
    }
  },
  get production() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      helpCenterURL: process.env.VUE_APP_HELP_CENTER_URL,
      adminURL: process.env.VUE_APP_ADMIN_URL,
      instantBaseURL: process.env.VUE_APP_INSTANT_BASE_URL,
    }
  },

  isStaging: () => {
    return process.env.VUE_APP_ENV !== "production";
  }
}

export const getSetting = key => {
  if (config.isStaging()) {
    return config.staging[key]
  }
  return config.production[key]
}

export default {
  ...config,
  getSetting
}

export const serverDomain = () => {
  const fullPath = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
  let url = process.env.VUE_APP_API_DOMAIN;
  if (!url) {
    url = fullPath;
  }
  return url;
};


export const websiteDomain = () => {
  const fullPath = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
  let url = process.env.VUE_APP_WEB_DOMAIN;
  if (!url) {
    url = fullPath;
  }
  return url;
};

export const INSTANT_API_DOMAIN = process.env.VUE_APP_INSTANT_API_DOMAIN;
